/* DOVA – timer carrello 10 minuti + popup abbandono carrello + frecce articoli consigliati */
(function () {
  if (window.__dovaCartTimer) return;
  window.__dovaCartTimer = true;

  var KEY = 'dova_cart_timer_end';
  var DURATION = 10 * 60 * 1000;
  var dialog = null;
  var busy = false;

  function getEnd() {
    try {
      var v = parseInt(localStorage.getItem(KEY), 10);
      return isNaN(v) ? null : v;
    } catch (e) {
      return null;
    }
  }

  function setEnd(v) {
    try {
      if (v === null) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, String(v));
    } catch (e) {}
  }

  function fmt(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(s / 60);
    var r = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r;
  }

  function injectStyles() {
    if (document.getElementById('dova-timeout-styles')) return;
    var st = document.createElement('style');
    st.id = 'dova-timeout-styles';
    st.textContent =
      '.dova-timeout{border:0;padding:28px 24px;width:min(92vw,360px);text-align:center;background:#fff;color:#0a0a0a;box-shadow:0 20px 60px rgba(0,0,0,.35);font-family:inherit}' +
      '.dova-timeout::backdrop{background:rgba(0,0,0,.55)}' +
      '.dova-timeout__title{margin:0 0 8px;font-size:1.25rem;line-height:1.3}' +
      '.dova-timeout__text{margin:0 0 22px;font-size:.875rem;opacity:.75}' +
      '.dova-timeout__actions{display:flex;gap:12px}' +
      '.dova-timeout__btn{flex:1;padding:14px 12px;font:inherit;font-weight:600;cursor:pointer;border:1px solid #0a0a0a;background:#fff;color:#0a0a0a}' +
      '.dova-timeout__btn--yes{background:#0a0a0a;color:#fff}' +
      '.dova-timeout__btn[disabled]{opacity:.6;cursor:default}';
    document.head.appendChild(st);
  }

  function buildDialog() {
    if (dialog) return dialog;
    injectStyles();
    dialog = document.createElement('dialog');
    dialog.className = 'dova-timeout';
    dialog.innerHTML =
      '<h2 class="dova-timeout__title">Desideri abbandonare il carrello?</h2>' +
      '<p class="dova-timeout__text">Il tempo di riserva del tuo articolo è scaduto.</p>' +
      '<div class="dova-timeout__actions">' +
      '<button type="button" class="dova-timeout__btn dova-timeout__btn--yes" data-dova-yes>Sì</button>' +
      '<button type="button" class="dova-timeout__btn" data-dova-no>No</button>' +
      '</div>';
    dialog.querySelector('[data-dova-yes]').addEventListener('click', leave);
    dialog.querySelector('[data-dova-no]').addEventListener('click', stay);
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      stay();
    });
    document.body.appendChild(dialog);
    return dialog;
  }

  function openDialog() {
    var d = buildDialog();
    if (!d.open) d.showModal();
  }

  function stay() {
    if (dialog && dialog.open) dialog.close();
    setEnd(Date.now() + DURATION);
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
  }

  function leave() {
    if (busy) return;
    busy = true;
    var btns = dialog.querySelectorAll('button');
    for (var i = 0; i < btns.length; i++) btns[i].disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var done = function () {
      setEnd(null);
      window.location.href = root;
    };
    fetch(root + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }).then(done, done);
  }

  function tick() {
    var el = document.querySelector('[data-dova-timer]');
    if (!el) {
      if (document.querySelector('.cart-drawer--empty')) setEnd(null);
      return;
    }
    var end = getEnd();
    if (!end) {
      end = Date.now() + DURATION;
      setEnd(end);
    }
    var left = end - Date.now();
    var nodes = document.querySelectorAll('[data-dova-timer-count]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = fmt(left);
    if (left <= 0 && !busy && !(dialog && dialog.open)) openDialog();
  }

  function start() {
    tick();
    setInterval(tick, 1000);
  }

  /* Frecce del carosello articoli consigliati */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-dova-rec-dir]') : null;
    if (!btn) return;
    var box = btn.closest('.dova-rec');
    var track = box ? box.querySelector('.dova-rec__track') : null;
    if (!track) return;
    track.scrollBy({ left: Number(btn.getAttribute('data-dova-rec-dir')) * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
